<script>
  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  let { RailsApp } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale
</script>

<div class="news border-success-subtle">
  <span class="p-0 px-2 bg-success text-white"><i class="bi bi-megaphone"></i> {@html i18n.t('news.0.date')}</span>
  <span class="p-1 px-2">{@html i18n.t('news.0.content')}</span>
</div>
